// Nur dieser Nebeneffekt: ES-Importe werden vor dem Rest von index.tsx ausgewertet, ein Aufruf dort käme zu spät
// (api/api.ts legt seine axios-Instanz schon beim Import an). Deshalb als eigenes Modul, das index.tsx zuerst lädt.
import { installiereWartungsAnbindung } from './wartung';

installiereWartungsAnbindung();
